import type { Dayjs } from 'dayjs';
import { type ForwardedRef, type ReactElement, useState } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import type { BaseDateInputProps } from './BaseDateInputProps';
import { DateInputDropdown } from './DateInputDropdown.tsx';
import DateRangeInputCalendar from './DateRangeInputCalendar';
import { defaultCalendarDateRanges } from '../../../predefinedDateRanges';

export type DateRangeInputProps<AllowOnlySince extends boolean = false> = BaseDateInputProps & {
  value: [Dayjs, AllowOnlySince extends true ? Dayjs | null : Dayjs] | null;
  onChange?: (val: [Dayjs, AllowOnlySince extends true ? Dayjs | null : Dayjs] | null) => void;
  allowSelectingOnlySince?: AllowOnlySince;
  ref?: ForwardedRef<HTMLInputElement>;
};

const DateRangeInput = <AllowOnlySince extends boolean = false>(
  props: DateRangeInputProps<AllowOnlySince>
): ReactElement => {
  const { onChange, minDate, maxDate, value, ref, ...rest } = props;
  const [open, setOpen] = useState(false);

  return (
    <DateInputDropdown
      {...rest}
      value={value}
      setOpen={setOpen}
      open={open}
      showClearable
      format={'dateRange'}
      onChange={onChange}
      allowSelectingOnlySince={props.allowSelectingOnlySince}
      ref={ref}
    >
      <DateRangeInputCalendar
        disabled={props.disabled}
        minDate={minDate}
        maxDate={maxDate}
        defaultValue={value}
        allowSelectingOnlySince={props.allowSelectingOnlySince}
        predefinedRanges={defaultCalendarDateRanges}
        onConfirm={(newValue): void => {
          onChange?.(newValue);
          setOpen(false);
        }}
        onCancel={(): void => {
          setOpen(false);
        }}
      />
    </DateInputDropdown>
  );
};

export default DateRangeInput;
